<template>
  <img alt="QR code" :src="img_src" />
</template>

<script>
import QRCode from "qrcode";

export default {
  props: {
    value: String,
  },
  data: function() {
    return {
      img_src: String,
    };
  },
  watch: {
    value() {
      this.generate();
    },
  },
  mounted() {
    this.generate();
  },
  methods: {
    generate() {
      if (!this.value) return;
      QRCode.toDataURL(this.value).then(url => {
        this.img_src = url;
      });
    },
  },
};
</script>
